import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaConfiguracoes } from "@/components/agenda/agenda-configuracoes";

export const Route = createFileRoute("/agenda/configuracoes")({
  component: () => (
    <AgendaShell>
      <AgendaConfiguracoes />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Configurações — Agenda — GPS Drive" }] }),
});
